/**
 * Match details are now shown inline on the create page.
 * This route redirects back to create to avoid broken deep links.
 */

import { Redirect } from 'expo-router';

export default function MatchDetailsRoute() {
  return <Redirect href="/app/create" />;
}
